import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '../../normal/GeneralCheckbox';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
  }).isRequired,
};

const defaultProps = {
  label: '',
};

const GeneralCheckbox = props => {
  const {
    id,
    label,
    input: { value, onChange },
    meta: { error, touched },
    oldValue,
    isEditing,
    disabled,
  } = props;

  return (
    <Checkbox
      id={id}
      label={label}
      value={isEditing ? value : oldValue}
      oldValue={oldValue}
      onChange={onChange}
      errMsg={error}
      touched={touched}
      disabled={!isEditing && disabled}
    />
  );
};

GeneralCheckbox.propTypes = propTypes;
GeneralCheckbox.defaultProps = defaultProps;

export default GeneralCheckbox;
